import { Icon, TextEllipsis } from '@aibees/shared/components';
import { capitalize, classnames } from '@aibees/shared/utils';
import { Box, Skeleton, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { DetailInfoProps as Props } from './types';

export const DetailInfo = memo(
  ({
    className,
    children,
    icon,
    label,
    value,
    subData,
    isLoading,
    onlyTitle,
  }: Props) => {
    if (!isLoading) {
      return (
        <Styled.Wrapper
          className={classnames('DetailInfo', className)}
          sx={SX.root}
          gap={1}
        >
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="flex-start"
            gap={0.5}
          >
            {icon && (
              <Stack alignItems="center" justifyContent="center">
                <Icon name={icon} color="grey.500" size={18} />
              </Stack>
            )}
            <Typography sx={SX.label} variant="body4" color="grey.700">
              {label}:
            </Typography>
            {!onlyTitle && (
              <TextEllipsis
                variant="body4"
                color="grey.700"
                fontWeight={700}
                value={
                  typeof value === 'string'
                    ? capitalize(value) || 'N/A'
                    : undefined
                }
              />
            )}
            {subData &&
              (typeof subData === 'string' ? (
                <Box sx={SX.subData}>{capitalize(subData)} </Box>
              ) : (
                subData
              ))}
          </Stack>
          {children}
        </Styled.Wrapper>
      );
    }
    return <Skeleton animation="wave" variant="rounded" sx={SX.skeleton} />;
  }
);

DetailInfo.displayName = 'DetailInfo';
